import request from "../api/httpClient.js";
import getEndpoint from "../utils/getEndpoint.js";

export const sendSignupOtp = async (payload) => {
  return await request(getEndpoint("otp", "sendSignupOtp"), { body: payload });
};

export const sendResetPasswordOtp = async (payload) => {
  return await request(getEndpoint("otp", "sendResetPasswordOtp"), {
    body: payload,
  });
};
